(function() {
    'use strict';

    angular.module('wamasysApp').directive('smartphoneHandoffs', smartphoneHandoffs);

    smartphoneHandoffs.$inject = ['$http', '$window', '$timeout'];

    function smartphoneHandoffs($http, $window, $timeout) {
        return {
            restrict: 'E',
            scope: {documentType: '@', documentId: '=', document: '=?', onUpdated: '&?', onStatus: '&?'},
            templateUrl: 'app/components/smartphone-handoffs/smartphone-handoffs.html',
            link: function(scope) {
                var generation = 0;
                var page = 0;
                var baseUrl = 'api/smartphone/handoffs';
                scope.handoffs = [];
                scope.refresh = function() { page = 0; load(false); };
                scope.next = function() { load(true, page + 1); };
                scope.retry = retry;
                scope.downloadSource = downloadSource;
                scope.loadAttachments = loadAttachments;
                scope.downloadAttachment = downloadAttachment;
                // Seuls des diagnostics connus choisissent une traduction ; les codes bruts restent dans les détails.
                var reasons = ('PAYMENT_ITEM_MISSING PAYMENT_ITEM_MISMATCH PAYMENT_CONTRACT_MISMATCH ' +
                    'PAYMENT_SERVICE_DUPLICATED_IN_COLLECTION PAYMENT_ALLOCATIONS_MISSING PAYMENT_SERVICE_MISSING ' +
                    'PAYMENT_SERVICE_MISMATCH PAYMENT_SERVICE_DUPLICATED PAYMENT_AMOUNT_INVALID ' +
                    'PAYMENT_ALLOCATION_MISMATCH PAYMENT_RECEIPT_MISSING PAYMENT_TOTAL_MISSING INVALID_PAYMENT ' +
                    'PAYMENT_RECONCILIATION_REQUIRED READING_RECONCILIATION_REQUIRED MISSING_READING ' +
                    'ASSIGNMENT_REVIEW_REQUIRED RETRY_REQUIRED OFFICE_REVIEW_REQUIRED').split(' ');
                scope.issueKey = function(anomaly, field) {
                    var reason = reasons.indexOf(anomaly.reason) >= 0 ? anomaly.reason : 'OFFICE_REVIEW_REQUIRED';
                    return 'global.handoff.issues.' + reason + '.' + field;
                };
                scope.statusKey = function(row) {
                    var status = row.processingStatus;
                    if (!row.received) status = 'RECEIVING';
                    else if (['PENDING', 'PROCESSING', 'ANOMALY', 'READY', 'VALIDATED'].indexOf(status) < 0) status = 'UNKNOWN';
                    if (status === 'READY' && scope.documentType === 'RF') status = 'RF_READY';
                    return 'global.handoff.status.' + status;
                };
                scope.itemLabel = function(anomaly) {
                    if (anomaly.itemId == null || !scope.document) return null;
                    var document = scope.document;
                    var label = null;
                    // Utiliser le document autorisé déjà chargé, sans télécharger le dépôt contenant les données personnelles.
                    angular.forEach(document.contratCollectionLists || [], function(item) {
                        if (String(item.id) === String(anomaly.itemId) && item.contrat) {
                            label = [item.contrat.referenceContrat, item.contrat.nomPersonne].filter(Boolean).join(' — ');
                        }
                    });
                    function readingLabel(item) {
                        if (String(item.idLigneReleveCompteur) !== String(anomaly.itemId)) return;
                        var meter = item.individualMeter || item.bulkMeter || {};
                        label = [item.referenceContrat, item.nomContrat, meter.numeroSerie].filter(Boolean).join(' — ');
                    }
                    angular.forEach(document.clusterReleveCompteurDTO || [], function(cluster) {
                        angular.forEach(cluster.ligneReleveCompteur || [], readingLabel);
                    });
                    angular.forEach(document.listLigneReleveCompteurBulkMeter || [], readingLabel);
                    return label;
                };

                scope.$watchGroup(['documentId', 'documentType'], function() {
                    scope.handoffs = [];
                    scope.hasNext = false;
                    scope.loading = false;
                    scope.error = false;
                    if (scope.onStatus) scope.onStatus({received: false});
                    scope.refresh();
                });
                scope.$on('$destroy', function() { generation++; });

                function load(append, requestedPage) {
                    var requestGeneration = ++generation;
                    requestedPage = requestedPage || 0;
                    if (!scope.documentId || (scope.documentType !== 'CL' && scope.documentType !== 'RF')) return;
                    scope.loading = true;
                    scope.error = false;
                    $http.get(baseUrl + '/office', {params: {
                        documentType: scope.documentType, documentId: scope.documentId, page: requestedPage, size: 20
                    }}).then(function(response) {
                        if (generation !== requestGeneration) return;
                        var data = response.data || {};
                        var rows = angular.isArray(data.content) ? data.content : [];
                        angular.forEach(rows, function(row) {
                            row.received = row.received === true || !!row.receivedAt;
                            // Le rapport est du texte, jamais du HTML ni du code à interpréter.
                            try {
                                row.report = angular.isString(row.processingReport)
                                    ? angular.fromJson(row.processingReport) : row.processingReport;
                            } catch (ignored) { row.reportUnavailable = true; }
                            row.report = row.report || {};
                            row.anomalies = angular.isArray(row.report.anomalies) ? row.report.anomalies : [];
                        });
                        scope.handoffs = append ? scope.handoffs.concat(rows) : rows;
                        page = requestedPage;
                        scope.hasNext = data.hasNext === true || data.last === false;
                        if (scope.onStatus) scope.onStatus({received: scope.handoffs.some(function(row) {
                            return row.received && row.applicationAuthorized;
                        })});
                    }, function() {
                        if (generation !== requestGeneration) return;
                        // Une API absente ou refusée n'est pas présentée comme zéro dépôt.
                        scope.error = true;
                    }).finally(function() {
                        if (generation === requestGeneration) scope.loading = false;
                    });
                }

                function idOf(row) { return encodeURIComponent(row.handoffId || row.id); }

                function retry(row) {
                    if (row.busy) return;
                    row.busy = true;
                    row.error = false;
                    $http.post(baseUrl + '/' + idOf(row) + '/retry', {}).then(function() {
                        scope.refresh();
                        if (scope.onUpdated) scope.onUpdated();
                    }, function() { row.error = true; }).finally(function() { row.busy = false; });
                }

                function downloadSource(row) {
                    download(baseUrl + '/' + idOf(row) + '/payload', 'depot-' + idOf(row) + '.json', row);
                }

                function loadAttachments(row) {
                    row.loadingAttachments = true;
                    $http.get(baseUrl + '/' + idOf(row) + '/attachments').then(function(response) {
                        var data = response.data;
                        row.attachments = angular.isArray(data) ? data : (data && data.content) || [];
                        row.attachmentsLoaded = true;
                    }, function() { row.error = true; }).finally(function() { row.loadingAttachments = false; });
                }

                function downloadAttachment(row, attachment) {
                    var id = encodeURIComponent(attachment.attachmentId || attachment.id);
                    download(baseUrl + '/' + idOf(row) + '/attachments/' + id, 'piece-' + id, row);
                }

                function download(url, filename, row) {
                    row.error = false;
                    $http.get(url, {responseType: 'blob'}).then(function(response) {
                        // $http conserve l'authentification ; aucun JWT dans une URL de téléchargement.
                        var objectUrl = $window.URL.createObjectURL(response.data);
                        var anchor = $window.document.createElement('a');
                        anchor.href = objectUrl;
                        anchor.download = filename;
                        $window.document.body.appendChild(anchor);
                        anchor.click();
                        $window.document.body.removeChild(anchor);
                        $timeout(function() { $window.URL.revokeObjectURL(objectUrl); }, 1000);
                    }, function() { row.error = true; });
                }
            }
        };
    }
})();
